module.exports = __webpack_public_path__ + "media/images/site/CENSINO_FUND_1_PREPARANDO_PARA_O_FUT-c128f1e24bde8cc148c57df3a4c05ea2.jpg";